export function applicableFee(amount, fee) {
  if (!fee) {
    return 0;
  }

  switch (fee.method) {
    case "Fixed":
      return fee.value;
    case "Percentage": {
      const totalFee = amount * (fee.value / 100);
      const minCharge = fee?.minCharge || 0;
      const maxCharge = fee?.maxCharge || Infinity;

      const applicableFee = Math.max(minCharge, Math.min(totalFee, maxCharge));

      return applicableFee;
    }
    default:
        return 0
  }
}